import { CookieStorage } from "~ui-lib";

// eslint-disable-next-line no-constant-condition
export const Storage = false ? new CookieStorage() : localStorage;
